if (!String.prototype.includes) {
    /**
     * Prototype method to check if a string contains another string.
     * The second parameter defines the index of the main string to begin the
     * serach at. If not passed, it defaults to 0 (the beginning of the string).
     *
     * @param {String} searchValue
     * @param {Number} [fromInde=0]
     * @return {Boolean}
     */
    String.prototype.includes = function (searchValue, fromIndex) {
        'use strict';
        if (typeof fromIndex !== 'number') {
            fromIndex = 0;
        }
        if (fromIndex + searchValue.length > this.length) {
            return false;
        } else {
            return this.indexOf(searchValue, fromIndex) !== -1;
        }
    };
}
